/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { DataMessageResponse_DietaryRequirements_ } from "../models/DataMessageResponse_DietaryRequirements_";
import type { DataMessageResponse_DietaryRequirementsPreferencesOptions_ } from "../models/DataMessageResponse_DietaryRequirementsPreferencesOptions_";
import type { DataResponse_DietaryRequirements_ } from "../models/DataResponse_DietaryRequirements_";
import type { DietaryRequirements } from "../models/DietaryRequirements";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class DietaryRequirementsService {
  /**
   * Update Dietary Requirements
   * Updates the dietary requirements for a user.
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_DietaryRequirements_ Successful Response
   * @throws ApiError
   */
  public static updateDietaryRequirementsApiV1DietaryRequirementsPut(
    xUserId: string,
    requestBody: DietaryRequirements,
  ): CancelablePromise<DataMessageResponse_DietaryRequirements_> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/dietary-requirements",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Dietary Requirements
   * Returns the dietary requirements for a user.
   * @param xUserId
   * @returns DataResponse_DietaryRequirements_ Successful Response
   * @throws ApiError
   */
  public static getDietaryRequirementsApiV1DietaryRequirementsGet(
    xUserId: string,
  ): CancelablePromise<DataResponse_DietaryRequirements_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/dietary-requirements",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Dietary Requirements Options
   * Get available dietary requirement preference options.
   * @returns DataMessageResponse_DietaryRequirementsPreferencesOptions_ Successful Response
   * @throws ApiError
   */
  public static getDietaryRequirementsOptionsApiV1DietaryRequirementsOptionsGet(): CancelablePromise<DataMessageResponse_DietaryRequirementsPreferencesOptions_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/dietary-requirements/options",
    });
  }
  /**
   * Get Dietary Requirements By Admin
   * Used by an admin to get information about a user's dietary requirements.
   * @param userId
   * @returns DataResponse_DietaryRequirements_ Successful Response
   * @throws ApiError
   */
  public static getDietaryRequirementsByAdminApiV1DietaryRequirementsUserIdGet(
    userId: string,
  ): CancelablePromise<DataResponse_DietaryRequirements_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/dietary-requirements/{user_id}",
      path: {
        user_id: userId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
